module.exports = __webpack_public_path__ + "images/emoji/snowman.7fc178c150bdd52874fe.png";